import React, { useState, useCallback } from "react";
import { Input, Space, DatePicker, Select } from "antd";
import { Dayjs } from "dayjs";
import FilterStyle from "./Filter.module.css";
import debounce from "lodash.debounce";
interface FilterSearchProps {
  confirm: () => void;
  close: () => void;
  dataIndex: string;
  label: string;
  isDate: boolean;
  filterValue: any;
  setFilter: React.Dispatch<React.SetStateAction<any>>;
  options?: { value: string | number; label: string }[];
}

interface FilterSelectProps {
  dataIndex: string;
  label: string;
  options: { value: string | number; label: string }[];
  filterValue: string | number | null;
  setFilter: React.Dispatch<React.SetStateAction<any>>;
  confirm: () => void;
  close: () => void;
}

export const FilterSearchDropdown: React.FC<FilterSearchProps> = ({
  confirm,
  close,
  dataIndex,
  label,
  isDate,
  filterValue,
  setFilter,
}) => {
  const [datePickerValue, setDatePickerValue] = useState<Dayjs | null>(null);

  const [searchTerm, setSearchTerm] = useState<string>(filterValue);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((value: string) => {
      setFilter(value);
    }, 500),
    [setFilter]
  );

  const handleChange = (value:string) => {
    setSearchTerm(value);
    debouncedSearch(value);
  };

  return (
    <div 
      className={FilterStyle.filterDiv}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Space direction="vertical">
        {!isDate ? (
          <Input
            id="search-by-name"
            className={FilterStyle.inputBox}
            value={searchTerm}
            onChange={(e) => {
              handleChange(e.target.value);
            }}
            placeholder={`Search ${label}`}
            allowClear
          />
        ) : (
          <DatePicker
            id="filter-by-date"
            className="w-full"
            onChange={(date) => {
              close();
              setDatePickerValue(date);
              setFilter(date ? date.format("YYYY-MM-DD") : "");
            }}
            value={datePickerValue}
          />
        )}
      </Space>
    </div>
  );
};

export const FilterSelectDropdown: React.FC<FilterSelectProps> = ({
  confirm,
  close,
  dataIndex,
  label,
  options,
  filterValue,
  setFilter,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleReset = () => {
    setFilter("");
    confirm();
  };

  return (
    <div 
      className={FilterStyle.filterDiv} 
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Space direction="vertical">
        <Select
          className={FilterStyle.selectStyle}
          placeholder={`Select ${label}`}
          value={filterValue}
          onChange={(value) => {
            close();
            setFilter(value);
          }}
          options={options}
          showSearch
          allowClear
          optionFilterProp="label"
        />
      </Space>
    </div>
  );
};
